export default __webpack_public_path__ + "static/media/ava-token.73b3f250.png";